import React from 'react';
import LoginForm from './LoginForm'

const LoginView = ({location}) => {
    return (
        <div className="app layout-fixed-header bg-white usersession">
            <div className="full-height">
                <div className="center-wrapper">
                    <div className="center-content">
                        <div className="row no-margin">
                            <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-6 col-md-offset-3">
                                <LoginForm query={location.query} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginView;



/** WEBPACK FOOTER **
 ** ./src/modules/auth/LoginView.js
 **/